import { render } from "./MultiselectItem.vue?vue&type=template&id=88042aec&scoped=true"
import script from "./MultiselectItem.vue?vue&type=script&lang=js"
export * from "./MultiselectItem.vue?vue&type=script&lang=js"

import "./MultiselectItem.vue?vue&type=style&index=0&id=88042aec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88042aec"]])

export default __exports__